import { FC, Fragment } from "react"

import BreadCrumbs from "../../../breadcrumbs"
import {
  DEFAULT_DATE_SLASH_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../../utils"
import { PricingSet } from "../../../../../types"

interface Props {
  pricingSet: PricingSet
}

const LoanProgramDetailsHeader: FC<Props> = ({ pricingSet }) => {
  return (
    <Fragment>
      <div>
        <BreadCrumbs
          pages={[
            {
              name: "Loan programs",
              href: "/loan-programs",
              current: false
            },
            {
              name: pricingSet.name ?? "",
              href: "#",
              current: true
            }
          ]}
        />
      </div>
      <div className="py-6 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="font-bold text-xl">{pricingSet.name}</div>
          <div className="pt-2">{`Created on ${formatDateTimeFromTimestamp(
            pricingSet.updated,
            DEFAULT_DATE_SLASH_FORMAT
          )}`}</div>
        </div>
        {/* TODO: Remove comment after adding functionality */}
        {/* <div className="flex items-center">
          <BBSwitch
            className="flex pr-6"
            enabled={false}
            setEnabled={() => {}}
            label="Set as default program"
          />
          <Button className="mr-2 bg-gray-200" onClick={() => {}}>
            <Pencil size={16} />
          </Button>
          <Button className="bg-gray-200" onClick={() => {}}>
            <Trash2 size={16} />
          </Button>
        </div> */}
      </div>
      <div className="py-6 flex flex-col border-t">
        <div className="font-bold">Set the order of your available loans</div>
        <div className="text-sm">
          Reorder the available loans (below) into the order you would like them
          to appear in the media created using this custom program set.
        </div>
      </div>
    </Fragment>
  )
}

export default LoanProgramDetailsHeader
